var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraOn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 587.71 425.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.11,114.51c.85,1,8.29-5.46,9.54-6.44,15.6-12.21,58.11-51.06,73.61-55.54,24.27-7.02,49.68,8.91,52.45,34.44l-.36,255.5c-7.24,29.38-38.4,41.64-64.05,25.02-19.98-12.94-42.25-34.43-61.65-49.6-2.82-2.21-6.15-5.62-9.54-6.44v32.61c0,42.46-49.79,80.51-90.09,81.26-84.43,1.57-169.91-1.85-254.59-1.4-5.89.03-11.31,1.66-17.9,1.39-47.9-1.98-87.48-42.29-88.87-90.13-2.17-74.24,1.8-152.74,1.4-227.75-.04-6.82-1.7-12.53-1.18-20.24C4.05,40.79,42.93,2.58,89.52.65c6.58-.27,12.01,1.36,17.9,1.39,85,.45,171.17-3.55,255.88-1.4,39.72,1.01,88.81,39.45,88.81,81.26v32.61ZM88.66,43.25c-27.57,3.1-42.93,20.42-45.73,47.62,4.6,78.9-6.19,164.91-.07,242.99,2.32,29.62,19.6,46.91,49.23,49.23h268.63c37.19-3.27,48.64-24.73,50.52-59.45,4.26-78.55-2-159.05-1.69-237.56-4.66-27.8-21.07-40.88-48.83-43.24l-272.07.4ZM546.74,333.17V92.77l-94.35,74.43-.38,89.93.38,1.61,94.35,74.43Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraOn);
export default __webpack_public_path__ + "static/media/camera_on.75c56914db771fed536ffc0be84cd11f.svg";
export { ForwardRef as ReactComponent };